import { cpItems } from "@/mocks/narutoData";
import SectionHeading from "./SectionHeading";

const tagColor: Record<string, string> = {
  羁绊: "bg-primary-500/15 text-primary-500 border-primary-500/30",
  刀尖: "bg-accent-500/15 text-accent-500 border-accent-500/30",
  意难平: "bg-accent-500/15 text-accent-500 border-accent-500/30",
  甜文: "bg-secondary-500/15 text-secondary-500 border-secondary-500/30",
  细水长流: "bg-primary-500/15 text-primary-500 border-primary-500/30",
  日常: "bg-secondary-500/15 text-secondary-500 border-secondary-500/30",
};

export default function CpSection() {
  return (
    <section id="cp" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="CP专题"
          title="人气CP与感情线同人导航"
          desc="从最强羁绊到温柔守护，围绕人气CP整理的同人专题，带你读懂那些没说出口的心意。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cpItems.map((cp) => (
            <article
              key={cp.id}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-secondary-500/50"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-500/15 text-secondary-500">
                  <i className="ri-heart-3-fill text-xl" />
                </span>
                <span
                  className={`rounded-full border px-2.5 py-1 text-xs ${tagColor[cp.tag] || tagColor["日常"]}`}
                >
                  {cp.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950">{cp.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cp.desc}</p>
              <div className="mt-auto flex items-center justify-between pt-5">
                <span className="text-xs text-foreground-500">{cp.count} 篇合集</span>
                <button className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 transition-colors hover:text-primary-400">
                  浏览 <i className="ri-arrow-right-line" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}